import React from 'react';

/**
 * Dashboard Card Component
 */
export const DashboardCard: React.FC<{
  title: string;
  value: string;
  color: 'blue' | 'green' | 'yellow' | 'red';
}> = ({ title, value, color }) => {
  const colorClasses = {
    blue: 'bg-blue-500',
    green: 'bg-green-500',
    yellow: 'bg-yellow-500',
    red: 'bg-red-500',
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className={`w-12 h-12 rounded-full ${colorClasses[color]} mb-4`} />
      <h3 className="text-gray-500 text-sm">{title}</h3>
      <p className="text-3xl font-bold">{value}</p>
    </div>
  );
};
